import styled from 'styled-components';

export const Section = styled.section`
  margin: 0 -0.5rem;
  overflow: hidden;
  padding: 1.5rem 0 1rem;
  position: relative;

  &:first-child {
    margin-top: -2rem;
    padding-top: 2rem;
  }

  &:last-child {
    border-bottom-width: 0;
  }

  @media ${(props) => props.theme.breakpoints.sm} {
    border: solid 4px var(--theme-color-text);
    box-shadow: 6px 6px 0 0 var(--theme-color-section);
    margin: 0 auto 2rem;
    padding: 0;

    &:first-child {
      margin-top: 0;
      padding-top: 0;
    }

    &:last-child {
      border-bottom-width: 4px;
    }
  }

  @media ${(props) => props.theme.breakpoints.lg} {
    margin: 0 auto 4rem;
    max-width: ${(props) => props.theme.maxHeaderWidth};
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media ${(props) => props.theme.breakpoints.lg} {
    display: grid;
    grid-template-areas: 'content image';
    grid-template-columns: 3fr 2fr;

    &[data-align='right'] {
      grid-template-areas: 'image content';
      grid-template-columns: 2fr 3fr;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: content;
  padding: 1rem;
  z-index: 1;

  @media ${(props) => props.theme.breakpoints.lg} {
    padding: 1rem 2rem;
  }

  img {
    border-radius: 10px;
    margin-bottom: 1rem !important;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: image;
  justify-content: flex-start;
  margin: 0 auto;
  max-width: 340px;
  z-index: 0;

  @media ${(props) => props.theme.breakpoints.md} {
    max-width: 400px;
  }
`;

// required to ensure image is in the same stacking context as pseudo elements
export const ImageRotate = styled.div`
  transform: rotate(4deg);

  &[data-align='right'] {
    transform: rotate(-3deg);
  }
`;

export const ProductImage = styled.div`
  background: var(--theme-color-always-light);
  border: solid 4px var(--theme-color-text);
  font-size: 0;
  margin: 15px 0;
  padding: 10px;
  position: relative;

  &:before,
  &:after {
    background: var(--theme-color-section);
    content: ' ';
    height: 100%;
    left: auto;
    position: absolute;
    right: 10px;
    top: 0;
    width: 100%;

    &[data-align='right'] {
      left: -10px;
      right: auto;
    }
  }

  &:before {
    transform: skew(-4deg) rotate(-12deg);
    z-index: -1;
  }

  &:after {
    transform: rotate(12deg);
    z-index: -2;
  }

  @media ${(props) => props.theme.breakpoints.md} {
    margin: 20px 0;
  }
`;

export const ProductImageFull = styled.div`
  margin: -1rem;
  min-height: 80vmin;
  min-width: 80vmin;
`;

export const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const Background = styled.div`
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
`;

export const BackgroundImage = styled.div`
  @media ${(props) => props.theme.breakpoints.lg} {
    background: var(--theme-color-section);
    bottom: 0;
    height: 140%;
    left: 70%;
    position: absolute;
    right: auto;
    top: -20%;
    transform: rotate(10deg);
    width: 100%;

    &[data-align='right'] {
      left: auto;
      right: 70%;
    }
  }
`;
